import { render, staticRenderFns } from "./Überdachung.vue?vue&type=template&id=48262860&"
import script from "./Überdachung.vue?vue&type=script&lang=js&"
export * from "./Überdachung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports